import datetimeFormat from './datetime.js'
const filter = {
  install: function (Vue) {
    Vue.filter('datetimeFormat', datetimeFormat)
  }
}
export default filter



// WEBPACK FOOTER //
// ./src/filter/index.js